import { ITranslations } from "./languages";

export const LanguageData: ITranslations = {
  login: {
    login: 'log in',
    forgetPassword: 'Forgot your password',
    colofon: 'Colofon',
    inschrijven: 'Subscribe',
    benjenieuwhier: 'Are you new here? Please enter subscribe.',
    klaar: 'ready',
    username: 'Username',
    password: 'Password',
    dutch: 'Nederlands',
    english: 'English',
    manualDownload: 'Manual'
  },
  global: {
    back: 'Back',
    continue: 'CONTINUE',
    next: 'Next',
    done: 'Done',
    playagain: 'Play again'
  },
  register: {
    subscribe: 'Subscribe',
    requiredFields: 'These are required fields',
    passwordConfirm: 'Re-enter your password',
    emailAddress: 'Email address'
  },
  createAvatar: {
    'chooseYourAvatar': 'Choose your game character',
    'skinLight': 'skin color',
    'skinMiddle': 'skin color',
    'skinDark': 'skin color',
    'remarks': 'Choose your game character. If you are happy with your choice, click on continue!'
  },
  dashboard: {
    logout: 'Logout',
    chooseItem: 'Choose the correct item to open the level'
  },
  diploma: {
    thisisforyou: 'After everything you have done, this is for you!',
    instruction: 'Enter your email address and click on send to receive this email in your emailbox.',
    send: 'Send',
    ready: 'Ready'
  },
  games: {
    instruction: 'Instruction',
    goodbad: 'True or false',
    bad: 'False',
    good: 'True',
    helpingToughts: 'Helpful thinking',
    questions: 'Questions',
    chooseEmotion: 'Choose the matching emotion',
    stresshead: 'Stress head',
    moveArrow: 'Slide the arrow',
    wellDone: 'Well done, you may continue.',
    title_GameVideo: 'Video',
    title_GameMultipleChoice: 'Questions',
    title_GameMemory: 'Choose the matching emotion',
    title_GameHelpendeGedachten: 'Helpful thinking',
    title_GameStresshoofd: 'Stress head',
    title_GameGoodBad: 'True or false',
    title_GameClicker: 'Search',
    clicker_response_plural: 'Well done, you have found {{foundBroedels}} broodles!',
    clicker_response: 'Well done, you have found 1 broodle!',
    print_worksheet: 'print worksheet',
    clicker_beginner: 'Beginner',
    clicker_expert: 'Expert',
  }
};
